import { useIdleLogout } from '@/hooks/useIdleLogout';

/** Componente vazio que apenas monta o hook de logout por inatividade. */
export function IdleLogoutMount() {
  useIdleLogout();
  return null;
}
